import { SidebarListSkeleton } from '@/shared/components/AppSidebar/SidebarListSkeleton';
import { SectionShell } from '@/shared/components/SectionShell';
import { Skeleton } from '@/shared/components/ui/skeleton';

export function ProfilePendingState() {
  return (
    <SectionShell sidebar={<SidebarListSkeleton />}>
      <div className="flex flex-1 flex-col gap-4 p-4 sm:p-6" aria-busy="true">
        <Skeleton className="h-7 w-48" />
        <Skeleton className="h-4 w-full max-w-md" />
        <Skeleton className="h-48 w-full max-w-2xl" />
      </div>
    </SectionShell>
  );
}
